// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module__footer___2DOyn","button":"Footer-module__button___tI-7Y","buttons":"Footer-module__buttons___3GiST","bodyLink":"Footer-module__bodyLink___1pMY5"};